import logo from "./logo.png";

//eslint-disable-next-line
export default { logo };
